const skColors = {
 darkgreen: {
   600: "#265A68",
    500: "#41919E",
    400: "#7DB7BA",
    300: "#93D1D1",
   200: "#C2EAEF",
    100: "#E6F8FA",
   50: "#F5FEFF"
 },
  brightgreen: {
    600: "#3F7C36",
    500: "#579E4C",
    400: "#7FC275",
    300: "#A1DF97",
    200: "#D3FBC9",
    100: "#EEFFEB",
    50: "#F8FFF7"
  },
  turquoise: {
    600: "#15989B",
    500: "#1BC8CC",
    400: "#3BF4EA",
    300: "#92FCF2",
    200: "#ADFFF7",
    100: "#D6FFFA",
    50: "#EFFFFC"
  },
  blue: {
    600: "#4281A8",
    500: "#5AACCC",
    400: "#7DD9EF",
    300: "#A2ECF9",
    200: "#CAF5FF",
    100: "#EBFBFF",
    50: "#F4FDFF"
  },
  red: {
    600: "#B41915",
    500: "#DA5754",
    400: "#EA7D7D",
    300: "#F4AEA6",
    200: "#FFCECB",
    100: "#FFEAE9",
    50: "#FFF7F7"
  },
  orange: {
    600: "#DC7518",
    500: "#F89237",
    400: "#F9B175",
    300: "#F9C7A5",
    200: "#FFDAC5",
    100: "#FFECE3",
    50: "#FFF9F6"
  },
  yellow: {
    600: "#E09E1F",
    500: "#F1BA4F",
    400: "#F9CC75",
    300: "#FFDE9E",
    200: "#FFEFD1",
    100: "#FFF9EE",
    50: "#FFFCF6"
  },
  monochrome: {
   600: "#2D3335",
    500: "#5C6466",
    400: "#99A8AA",
    300: "#CCDCDD",
    200: "#E8F7F7",
    100: "#F4FBFB",
    50:"#FAFDFD"
  },
  grey: {
    600: "#666666",
    500: "#AAAAAA",
    400: "#D6D6D6",
    300: "#E6E6E6",
    200: "#F3F3F3",
    100: "#F8F8F8",
    50: "#FBFBFB"
  }


};

export default skColors;
